document.addEventListener('DOMContentLoaded', function () {
    console.log('Phyto calculator JS loaded');

    const volumeToggle = document.getElementById('volumeToggle');
    const volumeInput = document.getElementById('volume');
    const strainsSelect = document.getElementById('strains');
    const errorMessageDiv = document.getElementById('errorMessage');
    const doseText = document.getElementById('doseText');
    const productInfo = document.getElementById('productInfo');
    const calculateButton = document.getElementById('calculatePhytoButton');

    console.log({
        volumeToggle,
        volumeInput,
        strainsSelect,
        errorMessageDiv,
        doseText,
        productInfo,
        calculateButton
    });

    if (
        !volumeToggle ||
        !volumeInput ||
        !strainsSelect ||
        !errorMessageDiv ||
        !doseText ||
        !productInfo ||
        !calculateButton
    ) {
        console.error('Required DOM elements not found for Phytoplankton Calculator');
        return;
    }

    function convertVolumeDisplay() {
        const currentValue = parseFloat(volumeInput.value);

        if (!isNaN(currentValue)) {
            const isLiters = volumeToggle.checked;
            const newValue = isLiters ? currentValue * 3.785 : currentValue / 3.785;
            volumeInput.value = newValue.toFixed(2);
        }
    }

    function buildDoseLine(title, totalDose, strainCount) {
        let line = `<li><strong>${title}:</strong> ${totalDose.toFixed(2)} ml total (${(totalDose / 29.5735).toFixed(2)} oz total)`;

        if (strainCount > 1) {
            line += ` - ${strainCount} strains: ${(totalDose / strainCount).toFixed(2)} ml per strain (${(totalDose / (strainCount * 29.5735)).toFixed(2)} oz per strain)`;
        }

        line += `</li>`;
        return line;
    }

    function calculatePhytoDose() {
        const volume = parseFloat(volumeInput.value);
        const isLiters = volumeToggle.checked;
        const strainCount = parseInt(strainsSelect.value, 10);

        errorMessageDiv.style.display = 'none';
        errorMessageDiv.innerHTML = '';
        productInfo.style.display = 'none';
        doseText.innerHTML = '';

        let errorMsg = '';

        if (isNaN(volume) || volume <= 0) {
            errorMsg += 'Volume must be a positive number. ';
        }

        if (errorMsg) {
            errorMessageDiv.innerHTML = errorMsg.trim();
            errorMessageDiv.style.display = 'block';
            return;
        }

        const volumeGallons = isLiters ? volume / 3.785 : volume;

        if (volumeGallons < 10 || volumeGallons > 500) {
            errorMessageDiv.innerHTML = 'Volume must be between 10 and 500 gallons (or equivalent in liters).';
            errorMessageDiv.style.display = 'block';
            return;
        }

        const fishOnlyDose = volumeGallons * 1;
        const photosyntheticDose = volumeGallons * 3;
        const nonPhotosyntheticDose = volumeGallons * 5;

        doseText.innerHTML += buildDoseLine('Fish Only Aquarium', fishOnlyDose, strainCount);
        doseText.innerHTML += '<li><hr></li>';
        doseText.innerHTML += buildDoseLine('Photosynthetic Stony Coral Aquarium', photosyntheticDose, strainCount);
        doseText.innerHTML += '<li><hr></li>';
        doseText.innerHTML += buildDoseLine('Coral Aquarium with Non-Photosynthetic Filter Feeders', nonPhotosyntheticDose, strainCount);

        productInfo.style.display = 'block';
    }

    volumeToggle.addEventListener('change', convertVolumeDisplay);
    calculateButton.addEventListener('click', calculatePhytoDose);

    window.calculatePhytoDose = calculatePhytoDose;
});